import axios from 'axios';

export const getTipsterFeeTiers = (data: any) => {
  return axios.get(`/v1/tipsters/fee_tiers`);
};

export const getSalesRequest = (query: {
  period_filter: string;
  cursor?: string;
  type_filter: string;
  limit: number;
}) => {
  const { period_filter, cursor, type_filter, limit = 50 } = query;
  return cursor
    ? axios.get(
        `/v1/me/sales?period_filter=${period_filter}&income_source=${type_filter}&cursor=${cursor}&limit=${limit}`,
      )
    : axios.get(
        `/v1/me/sales?period_filter=${period_filter}&income_source=${type_filter}&limit=${limit}`,
      );
};

export const getBalanceRequest = (query: any) => {
  const cursor = query.cursor;
  return cursor === undefined
    ? axios.get(`/v1/me/balance?limit=50`)
    : axios.get(`/v1/me/balance?cursor=${cursor}&limit=50`);
};

export const getStatsRequest = (query: { period_filter: string }) => {
  const { period_filter } = query;
  return axios.get(`/v1/me/users_stats?period_filter=${period_filter}`);
};

export const editPayoutMethodRequest = (data: any) => {
  return axios.put(`/v1/me/payout_method`, data);
};
export const requestPayout = (amount: number) => {
  return axios.put(`/v1/me/payouts/request`, { amount });
};
